/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Movement_Breakdown_Toggle_OutInputs */

const vi_movement_breakdown_toggle_out = /** @type {(inputs: Movement_Breakdown_Toggle_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất`)
};

/**

* @param {Movement_Breakdown_Toggle_OutInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const movement_breakdown_toggle_out = /** @type {((inputs?: Movement_Breakdown_Toggle_OutInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Movement_Breakdown_Toggle_OutInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_movement_breakdown_toggle_out(inputs)
});